// src/components/Layout.jsx
import React, {useEffect, useRef, useState} from 'react';
import {Outlet} from 'react-router-dom';
import AppHeader from './AppHeader';
import BottomNav from './BottomNav';

export default function Layout() {
    const [isLandscapeLow, setIsLandscapeLow] = useState(false);

    const scrollContainerRef = useRef(null);
    const scrollPositionRef = useRef(0);


    // В Layout.jsx
    const saveScrollPosition = () => {
        if (scrollContainerRef.current) {
            const position = scrollContainerRef.current.scrollTop;
            scrollPositionRef.current = position;
            // Сохраняем только если скролл не в самом верху
            if (position > 10) {
                sessionStorage.setItem('reservListScroll', position.toString());
                // console.log('💾 Авто-сохранение позиции:', position);
            }
        }
    };

    const restoreScrollPosition = () => {
        const savedPosition = sessionStorage.getItem('reservListScroll');
        if (savedPosition) {
            const position = parseInt(savedPosition, 10);
            console.log('🎯 Восстановление из sessionStorage:', position);

            const attemptRestore = (attempt = 0) => {
                if (scrollContainerRef.current && scrollContainerRef.current.scrollHeight > position) {
                    scrollContainerRef.current.scrollTop = position;
                    console.log('✅ Успешно восстановлено');
                } else if (attempt < 10) {
                    console.log(`🔄 Попытка ${attempt + 1}/10`);
                    setTimeout(() => attemptRestore(attempt + 1), 50);
                }
            };
            attemptRestore();
        }
    };

    useEffect(() => {
        const check = () => {
            const landscape = window.matchMedia("(orientation: landscape)").matches;
            const lowHeight = window.innerHeight <= 600;
            setIsLandscapeLow(landscape && lowHeight);
        };

        check();
        window.addEventListener("resize", check);
        window.matchMedia("(orientation: landscape)").addEventListener("change", check);

        return () => {
            window.removeEventListener("resize", check);
            window.matchMedia("(orientation: landscape)").removeEventListener("change", check);
        };
    }, []);

    return (
        <div className="fixed inset-0 flex flex-col bg-gradient-to-br from-gray-50 to-gray-100">
            {/* Фиксированный хедер */}
            <AppHeader/>

            {/* Основной контент — прокручивается между хедером и футером */}
            <main
                ref={scrollContainerRef}
                onScroll={saveScrollPosition}
                className={`flex-1 overflow-y-auto ${isLandscapeLow ? 'pt-4' : 'pt-20'} pb-24`}
            >
                <Outlet context={{
                    scrollContainerRef,
                    scrollPositionRef,
                    restoreScrollPosition // ← передаём функцию восстановления
                }}/>
            </main>

            {/* Фиксированный футер */}
            <BottomNav/>
        </div>
    );
}
